import { render } from "./CustomSwitch.vue?vue&type=template&id=dc199b02&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=js"
export * from "./CustomSwitch.vue?vue&type=script&lang=js"

import "./CustomSwitch.vue?vue&type=style&index=0&id=dc199b02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc199b02"]])

export default __exports__